import Component from '@ux/component';
import Logo from '@ux/logo';
import React from 'react';
import PropTypes from 'prop-types';
import ContactUs from './contact-us';
import LoginLogout from './login-logout';
import Version from './version';
import Navigation from './navigation';
import { breakpoints } from './enums';

class NavigationHelp extends Component {
  componentDidMount() {
    this.breakpoint(...breakpoints);
  }

  componentWillUnmount() {
    this.breakup();
  }

  static getDerivedStateFromProps(props) {
    return {
      emptyNav: props.navigation.every(navItem => !navItem.caption)
    };
  }

  renderLogo(renderMobile) {
    const props = this.props;
    const { isMobile, tempLogo } = props;

    const logoClasses = this.classNames(
      'logo-text',
      'logo-gd',
      tempLogo && 'temp-logo-span'
    );
    const outsideLogoClasses = 'logo brand-logo';

    const wrapperClass = renderMobile ? 'nav-left-wrap-full' : 'nav-left-wrap';
    let homeUrl = '';
    if (props.urls && props.urls.home && props.urls.home.href) {
      homeUrl = props.urls.home.href;
    }

    return (
      <div className={ this.classNames(wrapperClass) }>
        <Logo
          className={ outsideLogoClasses }
          country={ props.countryName }
          href={ homeUrl }
          market={ props.market }
          messages={ props.messages }
          logos={ props.logos }
          showCountryNameOnLogo={ false }
          spanClass={ logoClasses }
          urlArgs={ props.urlArgs }
          urls={ props.urls }
          isMobile={ isMobile }
          tempLogo={ tempLogo }
        />
        <div className='version hidden-sm-down'>
          <Version value={ props.version } />
        </div>
      </div>
    );
  }

  renderNav(renderMobile) {
    const props = this.props;
    const className = renderMobile ? 'nav-help-set' : 'nav-help-set-full';
    return (
      <div className={ this.classNames(className) }>
        <div
          className={ this.classNames(
            'nav-help-separator',
            'hidden-md-down',
            props.tempLogo && 'temp-logo'
          ) }
        />
        <Navigation
          items={ props.navigation }
          renderMobile={ renderMobile }
          urls={ props.urls }
          loggedIn={ props.loggedIn }
          sso={ props.sso }
        />
      </div>
    );
  }

  render() {
    const props = this.props;
    const state = this.state;
    const isNotDesktop =
      ['mobile', 'phablet', 'tablet'].indexOf(state.breakpoint) !== -1;
    const renderMobile =
      isNotDesktop && !state.emptyNav && props.renderMobile !== false;
    const renderNav = !(typeof window === 'undefined' || state.emptyNav);

    return (
      <nav className='nav-help clearfix'>
        <div className='container-fluid'>
          <div className='nav-help-left-container'>
            { !renderMobile && this.renderLogo(renderMobile) }
            { renderNav && this.renderNav(renderMobile) }
            { renderMobile && this.renderLogo(renderMobile) }
          </div>
          <div className='nav-help-right-container'>
            <ContactUs
              urls={ props.urls }
              app={ props.app }
              currentHref={ props.currentHref }
            />
            <LoginLogout
              displayName={ props.displayName }
              isPro={ props.isPro }
              loggedIn={ props.loggedIn }
              urlArgs={ props.urlArgs }
              urls={ props.urls }
              sso={ props.sso }
            />
          </div>
        </div>
      </nav>
    );
  }
}

NavigationHelp.propTypes = {
  market: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
  sso: PropTypes.object,
  urls: PropTypes.array,
  urlArgs: PropTypes.object,
  loggedIn: PropTypes.boolean,
  isPro: PropTypes.boolean,
  displayName: PropTypes.string,
  currentHref: PropTypes.string,
  app: PropTypes.string,
  renderMobile: PropTypes.boolean,
  logos: PropTypes.array,
  countryName: PropTypes.string,
  navigation: PropTypes.object,
  isMobile: PropTypes.boolean,
  tempLogo: PropTypes.object,
  version: PropTypes.string
};

NavigationHelp.defaultProps = {
  features: {}
};

export default NavigationHelp;
